import moment from 'moment';
import numeral from 'numeral';
import {Parser} from 'expr-eval';

numeral.register('locale', 'tr', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function(number) {
        return number === 1 ? 'er' : 'ème';
    },
    currency: {
        symbol: '€'
    }
});

function parseLocalizedNumber(value, locale = 'tr') {
    if (locale === 'tr') {
        value = value.split(',');

        if (value[1]) {
            return value[0].replace(new RegExp('\\.', 'g'), '').concat('.', value[1]);
        } else {
            return value[0].replace(new RegExp('\\.', 'g'), '');
        }
    } else {
        return value;
    }
}

function parseNumber(value, type, locale = 'tr') {
    value = value ? String(value) : '';
    numeral.locale(locale);
    if (type === 'float') {
        if (locale === 'tr') {
            value = Number(value).toFixed(2);
            let valueMap = value.split('.');
            value = valueMap.join(',');
        }
        return numeral(value).format(`0,0.00`);
    } else {
        return numeral(value).format('0,0');
    }
}

function isFloat(number) {
    let secondPart = Number(number.toFixed(2).split('.')[1]);
    return secondPart > 0;
}

// TODO: Make this work for languages other than Turkish
function isLetter(str) {
    return str && str.length === 1 && str.match(/[ a-z | ü | ğ | ş | ı | ç | ö | İ]/i);
}

// Adds unit to emission values
function addUnit(val, unit) {
    return val != 0 ? `${val} ${unit}` : '';
}

export default {
    parseNumber,
    isLetter,
    addUnit,
    evaluateFormula(item, {key, formula, formula_fields}) {
        if (formula && item[key].value) {
            let input = {};
            formula_fields.forEach(fieldName => {
                if(item[fieldName] && item[fieldName].editedValue){
                    input[fieldName] = Number(parseLocalizedNumber(item[fieldName].editedValue));
                }
            });
            let parser = new Parser();
            let expr = parser.parse(formula);
            item[key].value = String(Number(expr.evaluate(input).toFixed(2)));

            return item[key].value;
        } else {
            return item[key].value;
        }
    },

    formatDate(date = new Date(), format) {
        return moment(date).format(format);
    },

    capitalizeFirstLetter(text, locale = 'tr') {
        let words = text.trim().split(' ');
        words = words.map(word => {
            if (isLetter(word[0])) {
                return word.charAt(0).toUpperCase() + word.toLocaleLowerCase(locale).slice(1);
            }
            return word;
        });
        return words.join(' ');
    },

    convertZeroValueToDash(value, locale) {
        let parsedValue = Number(parseLocalizedNumber(value, locale));
        return parsedValue === 0 ? '-' : value;
    },
    textToShortText(val) {
        if (val && val.length > 9) {
            let firstPart = val.slice(0, 3);
            let secondPart = val.slice(val.length - 5, val.length);
            return `${firstPart}...${secondPart}`;
        } else {
            return val;
        }
    },
    shortenText(str, value = 12) {
        if (str) {
            if (str.length > value) {
                return `${str.slice(0, value)}...`;
            } else {
                return str;
            }
        } else {
            return '';
        }
    },
    isFloat,
    absoluteNumber(val) {
        return Math.abs(val);
    },
    localizedRatioText(val, locale) {
        if (locale === 'tr') {
            return `%${val}`;
        } else {
            return `${val}%`;
        }
    }
};



// WEBPACK FOOTER //
// ./src/filters.js